import Shipment from '../../../types/api/shipment'
import Task from '../../../types/api/task'

export const SHIPMENT_HEADER_ROW_TYPE = 'shipment-header' as const
export const NO_SHIPMENT_HEADER_ROW_TYPE = 'no-shipment-header' as const

export type ShipmentHeaderRow = Shipment & {
    __rowType: typeof SHIPMENT_HEADER_ROW_TYPE
}

export type NoShipmentHeaderRow = {
    __rowType: typeof NO_SHIPMENT_HEADER_ROW_TYPE
}

export type DesignerTasksTableRow = ShipmentHeaderRow | NoShipmentHeaderRow | Task
